import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { companyFragment, viewerFragment, ownerFragment } from 'fragments'
import Path from 'routes/path'
import BusinessLayout from 'components/layouts/BusinessLayout'
import { getBillingLabel } from 'helper/getBillingLabel'
import { STATUS } from 'modules/reservation'

function ReservationContainer(props) {
  if (!props.data.reservation) return null
  const { reservation, company } = props.data
  const { billing, room, owner, user, uid, space } = reservation
  const userContactName = `${user.contact.familyName} ${user.contact.givenName}`

  function renderBilling() {
    const billingLabel = getBillingLabel(reservation)

    if (!billingLabel) return null

    return (
      <a
        href={`/companies/${company.username}/reservations/${uid}/billing`}
        target="_blank"
        className="business-reservation-detail__download"
      >
        <i className="icon icon-spm-download mr5" />
        {billingLabel}
      </a>
    )
  }

  return (
    <BusinessLayout
      title={i18n.t('server.business.reservation.title')}
      description={i18n.t('server.business.reservation.description')}
      {...props}
    >
      <div className="container">
        <h1 className="business__title">予約詳細</h1>
        <div className="business-reservation-detail__space">
          {room.thumbnails.results.length > 0 && (
            <div className="business-reservation-detail__space-box">
              <img
                src={room.thumbnails.results[0].url}
                alt={room.name}
                className="business-reservation-detail__space-box-img"
              />
            </div>
          )}
          <div className="business-reservation-detail__space-info">
            <a
              className="business-reservation-detail__space-info-link"
              href={Path.room(space.username, room.uid)}
              target="_blank"
            >
              <p className="business-reservation-detail__space-info-title">
                {room.name}
              </p>
            </a>
            <p className="business-reservation-detail__space-info-host">
              <img
                src={owner.profileImage}
                alt={owner.name}
                className="business-reservation-detail__icon"
              />
              {owner.corpName || owner.name}
            </p>
            {reservation.ownerTel && (
              <p className="business-reservation-detail__space-info-tel">
                tel：{reservation.ownerTel}
              </p>
            )}
          </div>
        </div>
        <div className="business-reservation__list business-reservation-detail__list">
          <table className="business-reservation__table">
            <tbody>
              <tr className="business-reservation-detail__line">
                <th className="business-reservation-detail__heading">URL</th>
                <td className="">
                  <a href={Path.room(space.username, room.uid)} target="_blank">
                    {Path.room(space.username, room.uid)}
                  </a>
                </td>
              </tr>
              <tr className="business-reservation-detail__line">
                <th className="business-reservation-detail__heading">
                  予約リクエスト
                </th>
                <td className="">{reservation.createdAtText}</td>
              </tr>
              <tr className="business-reservation-detail__line">
                <th className="business-reservation-detail__heading">予約ID</th>
                <td className="">{reservation.id}</td>
              </tr>
              <tr className="business-reservation-detail__line">
                <th className="business-reservation-detail__heading">利用者</th>
                <td>
                  <img
                    src={user.profileImage}
                    alt={userContactName}
                    className="business-reservation-detail__icon"
                  />
                  {userContactName}
                </td>
              </tr>
              <tr className="business-reservation-detail__line">
                <th className="business-reservation-detail__heading">利用日</th>
                <td className="business-reservation-detail__text">
                  <span className="mr10">{reservation.statedAtText}</span>
                  <br className="pc-hide__sm-show" />
                  {reservation.startedAtText}
                </td>
              </tr>
              <tr className="business-reservation-detail__line">
                <th className="business-reservation-detail__heading">料金</th>
                <td className="business-reservation-detail__text">
                  <span className="mr15">
                    {reservation.status === STATUS.REFUNDED
                      ? billing.totalCancelAmountForUserWithTaxText
                      : billing.totalPayAmountForUserWithTaxText}
                  </span>
                  <br className="pc-hide__sm-show" />
                  {reservation.statusText}
                  {renderBilling()}
                </td>
              </tr>
              <tr>
                <th className="business-reservation-detail__heading">
                  会社からの質問
                </th>
                <td className="business-reservation-detail__text-long">
                  <dl className="business-reservation-detail__explain">
                    {reservation.companyAnswers.results.map(result => (
                      <Fragment key={result.id}>
                        <dt className="business-reservation-detail__explain-heading">
                          {result.questionTitle}
                        </dt>
                        <dd className="business-reservation-detail__explain-text">
                          {result.description}
                        </dd>
                      </Fragment>
                    ))}
                  </dl>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </BusinessLayout>
  )
}

const withData = graphql(
  gql`
  query BusinessAccountReservationContainer($username: String!, $uid: String!) {
    company(username: $username) {
      ${companyFragment}
    }
    reservation(uid: $uid) {
      canShowReceipt(fromBusiness: true)
      id
      status
      statusText
      uid
      eventTypeText
      createdAtText(format: "long")
      startedAtText(format: "long")
      ownerTel
      billing {
        status
        totalPayAmountForUserWithTaxText
        totalCancelAmountForUserWithTaxText
        paymentMethod
      }
      space {
        username
      }
      room {
        name
        uid
        thumbnails(perPage: 1) {
          results {
            url
          }
        }
      }
      owner {
        ${ownerFragment}
        name
        profileImage
      }
      user {
        name
        profileImage
        contact {
          givenName
          familyName
        }
      }
      companyAnswers {
        results {
          id
          questionTitle,
          description,
        }
      }
    }
    viewer {
      ${viewerFragment}
      companies(filter: MANAGED) {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {
        username: props.match.params.username,
        uid: props.match.params.uid,
      },
    }),
  },
)(ReservationContainer)

function mapStateToProps(state) {
  return state
}
export default withRouter(connect(mapStateToProps)(withData))
